// extracted by mini-css-extract-plugin
module.exports = {"codeEditor":"CodeEditor_codeEditor__t8FmR","paramContainer":"CodeEditor_paramContainer__lLVhr","openDrawerIcon":"CodeEditor_openDrawerIcon__1Ph22"};